<template>
  <div class="la-container">
    <div class="la-title">标签</div>
    <!-- <van-tabs 
      class="la-tabs" 
      :line-height="'1px'" 
      :line-width="'16px'"
      :color="'#FF7486'"
      :title-active-color="'#FF7486'" 
      :ellipsis="false" 
      :title-inactive-color="'#666666'"
      @click="clickTab"
    >
      <van-tab class="la-tab" v-for="item in classes" :key="item.id" :title="item.labelName" :name="item.id"> -->
    <div class="la-tabs">
      <span 
        class="la-label"
        :class="{ 'la-selected': label.id == selectedId }"
        v-for="label in labels" 
        :key="label.id"
        @click="clickLabel(label.id)" 
      >{{ label.labelName }}</span>
    </div>
      <!-- </van-tab>
    </van-tabs> -->
  </div>
</template>

<script>
export default {
  data () {
    return {
      selectedId: '',
    }
  },
  props: {
    classes: {
      type: Array,
      default: () => {
        return []
      }
    },
    labels: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  methods: {
    clickLabel (id) {
      this.selectedId = id
      this.$emit('clickLabel', id)
    },
    clickTab (name) {
      this.$emit('clickTab', name)
    }
  }
}
</script>

<style lang="less" scoped>
.la-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 0 10px 0;
  .la-title {
    margin: 0 10px 5px 10px;
    font-size: 10px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #333333;
    line-height: 28px;
    text-align: left;
    border-width: 0 0 0.5px 0;
    border-style: solid;
    border-color: #F2F2F2;
  }
  .la-tabs {
    line-height: 1.6;
    padding: 0 3px;
  //   .la-tab {
      .la-label {
        padding: 3px 6px;
        margin: 0 3px;
        border-radius: 2px;
        border: 0.5px solid #E8E8E8;
        font-size: 6px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        color: #666666;
        white-space: nowrap;
      }
      .la-label.la-selected {
        color: #fff;
        border: 0.5px solid #FF7486;
        background: #FF7486;
      }
  //   }
  }
}
</style>